angular.module('picmonicpublic')
    .controller('EducatorsController', ['$scope', '$modal', 'IntercomService', 'User', '$cookies', 'UserService', function ($scope, $modal, IntercomService, User, $cookies, UserService) {
        $scope.formData = {};
        $scope.formVisible = false;
        $scope.email_regex = /^[a-z0-9._+]+@[a-z-_0-9.]+\.edu$/;
        $scope.formStatus = null;
        $scope.$emit('endInteraction');

        $scope.formData.market_id = $cookies.get('pls_user_lead', 100);

        IntercomService.trackEvent('educator-page-viewed');

        $scope.toggleForm = function () {
            if (!$scope.formVisible) {
                if(typeof(atlasEvent) !== 'undefined') {
                    atlasEvent('click', "educator_free_access");
                }
            }

            $scope.formVisible = !$scope.formVisible;
            angular.element('body').toggleClass('scroll-lock');
        };

        $scope.submitForm = function() {
            if($scope.eduForm.$valid) {

              if(typeof(atlasEvent) !== 'undefined') {
                  atlasEvent('click', "educator_free_access_submit");
              }

              User.post({ resource: 'educator' }, $scope.formData, function(res) {
                  if(res.error) {
                      $scope.formStatus = false;
                  } else {
                      $scope.formStatus = true;
                  }
              });
            }
        };

        $scope.showRegisterModal = function() {
            $cookies.put('pls_user_role', 'Educator');
            $modal.open({
                templateUrl: '/templates/modals/register-modal.html',
                windowClass: 'registration-cta-modal full-screen-modal',
                backdropClass: 'modal-body-reduced',
                controller: 'RegisterModalController',
                resolve: {
                    card: function () {
                        return undefined;
                    },
                    tab: function() {
                        return 'register';
                    },
                    redirect: function() {
                        return '/home';
                    }
                }
            });
        };
    }]);